var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_665_448316)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1078 4.73534C15.3481 4.26906 14.4549 4 13.5 4H5.5C2.743 4 0.5 6.243 0.5 9V15C0.5 16.4656 1.13385 17.786 2.14183 18.7013L16.1078 4.73534ZM6.5 20H13.5C16.257 20 18.5 17.757 18.5 15V9C18.5 8.68724 18.4711 8.38108 18.4159 8.08407L6.5 20ZM24.5 15.632V8.313C24.5 7.556 24.082 6.877 23.403 6.538C22.724 6.199 21.929 6.272 21.325 6.726C21.286 6.755 20.5 7.544 20.5 7.544V16.409C20.5 16.409 21.288 17.191 21.325 17.219C21.677 17.483 22.093 17.618 22.514 17.618C22.816 17.618 23.12 17.548 23.403 17.407C24.08 17.069 24.5 16.389 24.5 15.632Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1.20711,
    y1: 26.2929,
    x2: 26.7929,
    y2: -1.70711,
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_665_448316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOff);
export default __webpack_public_path__ + "static/media/video_off.6700b3b467481b406a004afbab2dc018.svg";
export { ForwardRef as ReactComponent };